/**
 * External dependencies
 */
import React from "react";
import { Translate } from "react-localize-redux";

/**
 * Internal dependencies
 */
import { navigateTo, goBack } from "../utils/navigation";

interface BackButtonProps {
  fallbackRoute?: string;
  transition?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  fallbackRoute,
  transition = "switch-close",
}) => {
  const previousPathname = window.previousPathname;
  const currentPathname = window.currentPathname;

  const handleClick = () => {
    /**
     * Need to do some dirty work here to make sure the back button works as expected.
     * If we jump from register to barbershop, we want to go back to frontpage not back to register when pressing backbutton, pretty edge case but still.
     * Same goes with recorevy page, we are kind of in a limbo state there, so we want to go back to frontpage.
     *
     * @NOTE Also if previuspage is barber and current page is barbershop, we will use fallback route as well.
     * Im running out of time so this is a quick fix for now. The rendering issue will happen because of redux state and barbershop page dispatching the order state on mount.
     */

    if (
      previousPathname === "/register" ||
      (previousPathname === "/recovery" && currentPathname.startsWith("/barbershop"))
    ) {
      navigateTo(fallbackRoute, transition);
      return;
    }

    // If we don't have a sensible previous page, use fallback if provided
    if (!previousPathname || previousPathname === currentPathname) {
      if (fallbackRoute) {
        navigateTo(fallbackRoute, transition);
        return;
      }
    }

    // Default: traverse browser history backwards to avoid 2-page loops
    goBack(1);
  };

  return (
    <button className="c-back-button" onClick={handleClick}>
      <Translate id="navigation.back" />
    </button>
  );
};

export default BackButton;
